import { Box, Card, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import NextPlanBillDetails from './next-plan-bill-detials.component';
import SubscriptionTabComponent from './subscription-tab.component';
import { useTranslation } from 'react-i18next';

const CurrentSubscriptionDetails = ({ currentPlanDetails, handleBuyPlan }) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const [height, setHeight] = useState(window.innerHeight);
  const hasSubscription = currentPlanDetails.has_subscription;
  const hasTrailPeriod = currentPlanDetails.has_trial_period;
  const defaultPlanName = currentPlanDetails.default_plan_name;
  const isAppsumoUser = currentPlanDetails.is_appsumo_user;
  const expireDate = currentPlanDetails.expire_date;

  const getSocialPlatformsView = () => {
    let plan = currentPlanDetails.plan_details.no_of_social_accounts;
    let planAddonSocialAccountsDetails = currentPlanDetails.plan_addon_detials?.find(
      (e) => e.name === 'no_of_social_accounts'
    );
    let total =
      plan.no_of_social_accounts_total +
      planAddonSocialAccountsDetails?.quantity * plan.no_of_social_accounts_addon -
      plan.no_of_social_accounts_addon;
    let currPlan = plan.no_of_social_accounts_current_used;
    let remaining = total - currPlan;
    if (remaining < 0) remaining = 0;
    return (
      <Card style={{ marginTop: 1, marginRight: 5, marginBottom: 5, padding: 10, borderRadius: 5, flex: 1 }}>
        <Typography style={{ fontWeight: 800, marginBottom: 10 }}>
          {translate('billing.subscription_info.social_platforms')}
        </Typography>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.total_social_accounts')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>{total}</Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.total_social_accounts_per_plan')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>{plan.no_of_social_accounts_plan}</Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.upgraded_social_accounts_per_plan')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>
            {plan.no_of_social_accounts_addon * planAddonSocialAccountsDetails?.quantity}
          </Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.remaining_social_accounts')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>{remaining}</Typography>
        </Box>
      </Card>
    );
  };

  const getUsersView = () => {
    let plan = currentPlanDetails.plan_details.no_of_users;
    let planAddonUsersDetails = currentPlanDetails.plan_addon_detials?.find((e) => e.name === 'no_of_users');
    let total =
      plan.no_of_users_total + planAddonUsersDetails?.quantity * plan.no_of_users_addon - plan.no_of_users_addon;
    let currPlan = plan.no_of_users_current_used;
    let remaining = total - currPlan;
    if (remaining < 0) remaining = 0;
    return (
      <Card style={{ marginTop: 1, padding: 10, marginBottom: 5, borderRadius: 5, flex: 1 }}>
        <Typography style={{ fontWeight: 800, marginBottom: 10 }}>
          {translate('billing.subscription_info.users')}
        </Typography>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>{translate('billing.subscription_info.total_users')}</Typography>
          <Typography style={{ fontWeight: 800 }}>{total}</Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.total_users_per_plan')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>{plan.no_of_users_plan}</Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.upgraded_users_per_plan')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>
            {plan.no_of_users_addon * planAddonUsersDetails?.quantity}
          </Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>{translate('billing.subscription_info.remaining_users')}</Typography>
          <Typography style={{ fontWeight: 800 }}>{remaining}</Typography>
        </Box>
      </Card>
    );
  };

  const getWhiteLabelView = () => {
    let cName = currentPlanDetails.plan_details.cname;
    return (
      <Card style={{ marginTop: 1, padding: 10, marginBottom: 5, borderRadius: 5, flex: 1 }}>
        <Typography style={{ fontWeight: 800, marginBottom: 10 }}>
          {translate('billing.subscription_info.white_label')}
        </Typography>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 5,
            color: theme.palette.text.secondary,
          }}
        >
          <Typography style={{ fontWeight: 800 }}>
            {translate('billing.subscription_info.white_label_available')}
          </Typography>
          <Typography style={{ fontWeight: 800 }}>
            {cName.has_cname ? translate('common.yes') : translate('common.no')}
          </Typography>
        </Box>
      </Card>
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={hasSubscription ? 8 : 12}>
          {/* <Grid item xs={8}> */}
          <Card
            style={{
              maxHeight: 'calc(84vh)',
              minHeight: 'calc(84vh)',
              height: height,
            }}
          >
            <Card
              style={{
                maxHeight: 'calc(58vh)',
                minHeight: 'calc(58vh )',
                height: height,
                padding: 10,
                overflowY: 'auto',
                boxShadow: 'none',
              }}
            >
              <Grid container xs={12}>
                <Grid item xs={6} sx={{ display: 'flex' }}>
                  {getSocialPlatformsView()}
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex' }}>
                  {getUsersView()}
                </Grid>
              </Grid>

              <Grid container xs={12} sx={{ marginTop: '20px' }}>
                <Grid item xs={6} sx={{ display: 'flex' }}>
                  {getWhiteLabelView()}
                </Grid>
              </Grid>
            </Card>
            <NextPlanBillDetails
              hasSubscription={hasSubscription}
              hasTrailPeriod={hasTrailPeriod}
              expireDate={expireDate}
              isAppsumoUser={isAppsumoUser}
              defaultPlanName={defaultPlanName}
              handleBuyPlan={handleBuyPlan}
            />
          </Card>
        </Grid>
        {hasSubscription && (
          <Grid item xs={4}>
            <Card
              style={{
                maxHeight: 'calc(94vh - 100px)',
                minHeight: 'calc(94vh - 100px)',
                height: height,
              }}
            >
              <SubscriptionTabComponent
                planAddonDetails={currentPlanDetails.plan_addon_detials}
                currentPlanDetails={currentPlanDetails}
              />
            </Card>
          </Grid>
        )}
      </Grid>
    </>
  );
};
export default CurrentSubscriptionDetails;
